import StripeCCFields from './StripeCCFields'

export default StripeCCFields
